'use client';

import React, { useState } from 'react';
import { MedRMStatus, NewActivityLog, PushToCRMGroup, AddToListModal } from 'src/components';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { PulseButton } from 'src/components/PulseUI';

interface ProfileDrawerActionsProps {
  /** Provider entity from OldProfileContext */
  provider: MedScout.Opportunity;
}

const ProfileDrawerActions: React.FC<ProfileDrawerActionsProps> = ({
  provider,
}) => {
  const [showAddToListModal, setShowAddToListModal] = useState(false);
  const isSystem = provider?.type === 'system';

  return (
    <div
      className="flex items-center gap-2 w-full h-10"
      data-testid="profile-drawer-actions"
    >
      <NewActivityLog testIdPrefix="profile-drawer" />
      <PushToCRMGroup
        newHeaderView={true}
        provider={provider}
        variant="regular"
        testIdPrefix="profile-drawer"
      />
      <MedRMStatus provider={provider} testIdPrefix="profile-drawer" />
      {!isSystem && (
        <PulseButton
          startDecorator={faPlus}
          variant="outline"
          size="sm"
          color="neutral"
          className="bg-white"
          onClick={() => setShowAddToListModal(true)}
          aria-label="Add to List"
          data-testid="profile-drawer-add-to-list-button"
        >
          Add to List
        </PulseButton>
      )}
      <AddToListModal
        isOpen={showAddToListModal}
        onClose={() => setShowAddToListModal(false)}
        mode="add"
        providers={[provider]}
      />
    </div>
  );
};

export default ProfileDrawerActions;
